import { useTranslation } from "react-i18next";
import { animeArticles } from "@/mocks/animeData";
import RankingItem from "@/components/base/RankingItem";

export default function RankingSection() {
  const { t } = useTranslation();
  const seasonRanking = [...animeArticles]
    .sort((a, b) => a.seasonRank - b.seasonRank)
    .slice(0, 6);
  const totalRanking = [...animeArticles]
    .sort((a, b) => a.totalRank - b.totalRank)
    .slice(0, 6);

  return (
    <section className="py-14 md:py-20">
      <div className="container-site">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {t("home.rankingsTitle")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            {t("home.rankingsSubtitle")}
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
          <div className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-fire-line text-primary-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-800 font-heading">
                本季热榜
              </h3>
            </div>
            <div className="space-y-1">
              {seasonRanking.map((article, index) => (
                <RankingItem
                  key={article.id}
                  article={article}
                  rank={index + 1}
                  type="season"
                />
              ))}
            </div>
          </div>
          <div className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-trophy-line text-accent-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-800 font-heading">
                总榜排名
              </h3>
            </div>
            <div className="space-y-1">
              {totalRanking.map((article, index) => (
                <RankingItem
                  key={article.id}
                  article={article}
                  rank={index + 1}
                  type="total"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}